import { render } from "./TicketNew.vue?vue&type=template&id=b55c5a58&ts=true"
import script from "./TicketNew.vue?vue&type=script&lang=ts"
export * from "./TicketNew.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__